import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";

export class Unfiltered extends SeoMetaDataHandler {

	public async canHandle(sortState: SortingState): Promise<boolean> {
		const metaRankingSortSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);

		return metaRankingSortSelected;
	}

	protected selfHandle(): Promise<ISeoMetaDataInfo> {
		const year = this.getCurrentYearForSeo();

		const seoInfo = {
			title: `Studyportals World University Meta Rankings ${year}`,

			description:
				`Discover the best universities in the world with Studyportals University Meta Rankings. ` +
				`Our algorithm summarises other university ranking sites to give you the best overview.`,
		};

		return Promise.resolve(seoInfo);
	}
}
